import type { RecipeStep } from "@recipevault/shared";

/**
 * Steps parallel with `stepId`, computed SYMMETRICALLY: Y is parallel with X if
 * X ∈ Y.parallelWith OR Y ∈ X.parallelWith. The editor/LLM may write the relation
 * one-directionally, so we union both directions. Returns ids that exist in `steps`,
 * excluding `stepId` itself, de-duplicated, in `steps` order.
 */
export function parallelStepIdsOf(steps: ReadonlyArray<RecipeStep>, stepId: string): string[] {
  const self = steps.find((s) => s.id === stepId);
  if (!self) return [];
  const present = new Set(steps.map((s) => s.id));
  const out: string[] = [];
  const seen = new Set<string>();
  for (const s of steps) {
    if (s.id === stepId) continue;
    const forward = self.parallelWith.includes(s.id);
    const backward = s.parallelWith.includes(stepId);
    if ((forward || backward) && present.has(s.id) && !seen.has(s.id)) {
      seen.add(s.id);
      out.push(s.id);
    }
  }
  return out;
}
